module.exports = __webpack_public_path__ + "img/illustration_billing.157030f6.svg";